import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-su_013",
  "use": "icon-su_013-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-su_013\"><defs><style>#icon-su_013 .cls-1{fill:none;opacity:0;}</style></defs><g id=\"icon-su_013_レイヤー_2\" data-name=\"レイヤー 2\"><g id=\"icon-su_013_icon\"><rect class=\"cls-1\" width=\"24\" height=\"24\" /><path class=\"cls-2\" d=\"M15,4V2H9V4H3V6H5V19a2,2,0,0,0,2,2H17a2,2,0,0,0,2-2V6h2V4ZM9,18H7V8H9Zm4,0H11V8h2Zm4,0H15V8h2Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol